export class SentryApplication {
  static sentryInitializer(dns, version) {
    return window.Sentry && window.location.hostname != "localhost" ? Sentry.init({
      dsn: dns,
      release: "quiteja-landing-page@" + version,
      tracesSampleRate: 1.0,
    }) : null;
  }
}
